import React from "react";
import "./format.css";
import video from "../../asset/videos/video2.mp4";

export default function Format(props) {
  return (
    <div className="carousel-slide">
      <video 
        className="carousel-video"
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
